import { motion } from "framer-motion";
import { CountUp } from "../bits";
import { fadeUp } from "./shared";

export function StatsSection({ stats }) {
  return (
    <section className="relative z-10 max-w-6xl mx-auto px-5 pb-14 -mt-14">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {stats.map((s, i) => (
          <motion.div key={s.testid} initial="hidden" whileInView="show" viewport={{ once: true }}
            variants={{ ...fadeUp, show: { ...fadeUp.show, transition: { delay: i * 0.08, duration: 0.5 } } }}
            className="bg-surface rounded-2xl p-5 border border-brd shadow-md shadow-turq-900/5 text-center">
            <div className="font-head font-black text-2xl text-turq-900 dark:text-turq-300">
              <CountUp value={s.value ?? 0} testid={s.testid} />
            </div>
            <div className="text-[11px] text-mutext mt-1">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
